import { useEffect, useState } from "react";
import "./App.scss";
import Navigation from "./components/Navigation";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FrontPage from "./pages/Frontpage";
import Proces from "./pages/Proces";
import Services from "./pages/Services";
import Footer from "./pages/Footer";
import { Route, Routes } from "react-router-dom";
import Projects, { Tour, Customer } from "./pages/Projects";
import Preview from "./pages/Preview";
import Vision from "./pages/Vision";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import RequireAuth from "./components/RequireAuth";
import { AuthProvider } from "./contexts/AuthContext";
import { getAllTours, getAllCustomers } from "./firebase";
import { getTourPath } from "./utils";

function App() {
  const [tours, setTours] = useState<Tour[]>([]);
  const [customers, setCustomers] = useState<Customer[]>([]);

  const newWebPage = (
    <>
      <Navigation />
      <FrontPage tours={tours} customers={customers} />
      <Services />
      <About />
      <Projects tours={tours} customers={customers} />
      <Proces />
      <Vision />
      <Contact />
      <Footer />
    </>
  );

  useEffect(() => {
    getAllTours().then((data) => {
      setTours(data);
    });
    getAllCustomers().then((data) => {
      setCustomers(data);
    });
  }, []);

  const tourRoutes = tours
    .map((tour) => ({ tour, path: getTourPath(tour, customers) }))
    .filter((entry): entry is { tour: Tour; path: string } => entry.path !== null);

  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          <Route path="/" element={newWebPage}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <Admin tours={tours} customers={customers} />
              </RequireAuth>
            }
          ></Route>
          {tourRoutes.map(({ tour, path }) => (
            <Route key={tour.id} path={`/${path}`} element={<Preview tour={tour} />} />
          ))}
          <Route path="*" element={<h1>Siden kunne ikke findes</h1>}></Route>
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
